<div (click)="activeNav=null">
  <app-splash-screen></app-splash-screen>
  <div class="nav">
    <div class="relative text-gray-700">
      <div (click)="toggleNav()" class="nav-heading" [class.nav-heading-small]="smallNav">
          <div class="nav-logo" *ngIf="!smallNav">
              <img src="/assets/images/logo-small.svg" alt="Squads" />
              <span class="app-title">SQUADS</span>
              <span class="app-subtitle">by LiONFLENCE</span>
          </div>

          <img src="/assets/images/logo-small.svg" *ngIf="smallNav" alt="Squads" />
      </div>
      <div (click)="toggleNav()" class="absolute vertical-center nav-toggler right-0 mr-3 text-xl cursor-pointer" *ngIf="!smallNav">
        <span class="iconify" data-icon="ant-design:menu-outlined"></span>
      </div>
    </div>
    <div class="artist-dropdown" *ngVar="(artistContext.selectedArtist$ | async) as selectedArtist">
      <div class="artist-dropdown-content" *ngIf="selectedArtist">
        <div class="artist-avatar" [style.background-image]="'url(' + (selectedArtist.profileImage?.filename | urlEncode) + ')'"></div>
        <div class="title">{{ selectedArtist.name }}</div>
        <div class="subtitle"></div>
      </div>
      <div class="artist-dropdown-content" *ngIf="!selectedArtist">
        <div class="manager-avatar">AM</div>
        <div class="title">Artist Manager</div>
        <div class="subtitle">Alles ansehen</div>
      </div>
    </div>
    <div class="w-full bg-white artist-bar relative" [class.big]="smallNav">
      <div class="artist-bar-toggle" *ngIf="(user$ | async).roles.indexOf('ROLE_CRM_ADMIN') >= 0">
        <div (click)="toggleOnlyManaged()" class="text-xs cursor-pointer" *ngIf="(showOnlyManaged$ | async)">
          Alle anzeigen
        </div>
        <div (click)="toggleOnlyManaged()" class="text-xs cursor-pointer" *ngIf="!(showOnlyManaged$ | async)">
          Nur meine anzeigen
        </div>
      </div>
        <div slot="container-start">
            <div class="button-prev" (click)="artistCarousel.swiper.slidePrev()"></div>
        </div>
        <div slot="container-end">
            <div class="button-next" (click)="artistCarousel.swiper.slideNext()"></div>
        </div>
      <swiper-container #artistCarousel slides-per-view="7.5" [style.margin-right]="'3rem'">
        <swiper-slide>
            <div class="artist-bar-entry-wrapper" matRipple [class.active]="(selectedArtist$ | async) == null" (click)="selectArtist(null)">
                <div class="artist-bar-entry">
                    <div class="artist-bar-image">
                        <div class="media aspect-1-1 rounded-full">
                            <div class="overlay full bg-green-600"></div>
                            <div class="overlay top-center left-center text-white text-sm font-bold">
                                AM
                            </div>
                        </div>
                    </div>
                    <div class="artist-bar-content">
                        <div class="font-bold artist-name">Artist Manager</div>
                        <div (click)="$event.stopPropagation(); selectArtist(null)" class="outline-none text-xs inline-block">
                            Alles ansehen
                        </div>
                    </div>
                </div>
            </div>
        </swiper-slide>
          <swiper-slide *ngFor="let artist of (filteredArtists$ | async); trackBy: artistTracker">
              <div class="artist-bar-entry-wrapper" [class.active]="(selectedArtist$ | async)?.id == artist.id" (click)="selectArtist(artist)">
                  <div class="artist-bar-entry" matRipple>
                      <div class="artist-bar-image">
                          <div class="media aspect-1-1 rounded-full">
                              <div class="overlay full bg-gray-300"></div>
                              <div [style.background-image]="'url(' + (artist.profileImage?.filename | urlEncode) + ')'" class="overlay full bg-cover bg-center" *ngIf="artist.profileImage?.filename != null">
                              </div>
                          </div>
                      </div>
                      <div class="artist-bar-content">
                          <div class="font-bold artist-name">{{ artist.name }}</div>
                          <div (click)="$event.stopPropagation()"
                               [customRouterLink]="['/artists', artist.id]"
                               class="text-primary hover:underline outline-none text-xs inline-block">
                              Profil
                          </div>
                      </div>

                      <div class="dropdown" (click)="$event.stopPropagation()" [matMenuTriggerFor]="addressDropdown"></div>

                      <mat-menu #addressDropdown>
                          <div (click)="copyToClipboard(adr.address)" class="py-2 text-xs border-b border-gray-300 px-3 text-gray-700 cursor-pointer hover:bg-gray-100" *ngFor="let adr of artist.addresses">
                              {{ adr.address }}
                          </div>
                      </mat-menu>
                  </div>
              </div>
          </swiper-slide>
      </swiper-container>
    </div>
  </div>

  <mat-sidenav-container autosize (window:resize)="onResize($event)">
    <mat-sidenav #sidenav [mode]="sidenavMode" [(opened)]="opened">
      <div class="sidenav" [class.small-nav]="smallNav">
        <div class="user-box py-3 px-4" *ngIf="(user$ | async) as user">
          <div class="flex flex-wrap w-full">
            <div class="w-1/5">
              <div class="w-10 h-10 rounded-full text-white leading-10 text-center font-bold" [ngClass]="getInitialsBg(user.displayName ? user.displayName : user.username)">
                {{ getInitials(user.displayName ? user.displayName : user.username) }}
              </div>
            </div>
            <div class="w-4/5 nav-label account-label">
              <div class="leading-5 pl-2">
                <div class="text-primary text-lg">
                  {{ user.displayName ? user.displayName : user.username }}
                </div>
                <div [customRouterLink]="['/settings']" class="text-xs -mt-3 hover:underline text-gray-500 cursor-pointer inline-block">Einstellungen</div>
                <span class="text-gray-400 leading-6 text-xs inline-block mx-1">&bull;</span>

                <div (click)="logout()" class="text-xs -mt-3 hover:underline text-gray-500 cursor-pointer inline-block">Logout</div>
              </div>

            </div>
          </div>
        </div>
        <div class="mt-16 text-gray-700">
          <div [customRouterLink]="['/', 'messages']" matRippleColor="rgba(255,255,255,0.15)" class="nav-entry" [class.active]="isRouteActive('messages')" matRipple>
            <div class="icon">
              <span class="iconify" data-icon="fluent:mail-48-regular"></span>
            </div>
            <span class="nav-label">Nachrichten</span>
            <div class="indicator bg-red-700 text-white">{{ countUnread$ | async }}</div>
          </div>

            <div [customRouterLink]="['/', 'calendar']" matRippleColor="rgba(255,255,255,0.15)" class="nav-entry" [class.active]="isRouteActive('calendar')" matRipple>
                <div class="icon">
                    <span class="iconify" data-icon="fluent:calendar-ltr-24-regular" data-inline="false"></span>
                </div>
                <span class="nav-label">Kalender <span class="beta-badge">Beta</span></span>
            </div>

          <div class="nav-entry-wrapper" [class.active]="activeNav == 'cooperations'">
            <div (click)="setActiveNav('cooperations');$event.stopPropagation()" matRippleColor="rgba(255,255,255,0.15)" class="nav-entry" matRipple>
              <div class="icon">
                <span class="iconify" data-icon="fluent:handshake-20-regular"></span>
              </div>
              <span class="nav-label">Kooperationen</span>
            </div>
            <div class="nav-sub-entries">
              <div class="nav-sub-entry" [class.active]="isRouteActive('cooperations')" [customRouterLink]="['/', 'cooperations']">
                <div class="icon">
                  <span class="iconify" data-icon="fluent:handshake-20-regular"></span>
                </div>
                <span class="nav-label">Kooperationen</span>
              </div>
              <div class="nav-sub-entry" [class.active]="isRouteActive('campaign')" [customRouterLink]="['/', 'campaigns']">
                <div class="icon">
                  <span class="iconify" data-icon="fluent:megaphone-loud-24-regular"></span>
                </div>
                <span class="nav-label">Kampagnen</span>
              </div>
              <div class="nav-sub-entry" [class.active]="isRouteActive('events')" [customRouterLink]="['/', 'events']">
                <div class="icon">
                  <span class="iconify" data-icon="clarity:calendar-outline-badged"></span>
                </div>
                <span class="nav-label">Termine</span>
              </div>
              <div class="nav-sub-entry" [class.active]="isRouteActive('media')" [customRouterLink]="['/', 'media']">
                <div class="icon">
                  <span class="iconify" data-icon="bi:postcard-heart"></span>
                </div>
                <span class="nav-label">Medien</span>
              </div>
            </div>
          </div>

          <div [customRouterLink]="['/', 'artists']" matRippleColor="rgba(255,255,255,0.15)" class="nav-entry" [class.active]="isRouteActive('artists')" matRipple>
            <div class="icon">
              <span class="iconify" data-icon="fluent:star-line-horizontal-3-24-regular" data-inline="false"></span>
            </div>
            <span class="nav-label">Artists</span>
          </div>

          <div class="nav-entry-wrapper" [class.active]="activeNav == 'customer'">
            <div (click)="setActiveNav('customer');$event.stopPropagation()" matRippleColor="rgba(255,255,255,0.15)" class="nav-entry" matRipple>
              <div class="icon">
                <span class="iconify" data-icon="fluent:building-multiple-24-regular"></span>
              </div>
              <span class="nav-label">Kunden</span>
            </div>
            <div class="nav-sub-entries">
              <div class="nav-sub-entry" [class.active]="isRouteActive('companies')" [customRouterLink]="['/', 'companies']">
                <div class="icon">
                  <span class="iconify" data-icon="carbon:building-insights-3"></span>
                </div>
                <span class="nav-label">Unternehmen</span>
              </div>
              <div class="nav-sub-entry" [class.active]="isRouteActive('acquisitions')" [customRouterLink]="['/', 'acquisitions']">
                <div class="icon">
                  <span class="iconify" data-icon="ant-design:message-outlined"></span>
                </div>
                <span class="nav-label">Akquise</span>
              </div>
              <div class="nav-sub-entry" [class.active]="isRouteActive('contacts')" [customRouterLink]="['/', 'contacts']">
                <div class="icon">
                  <span class="iconify" data-icon="fluent:person-20-regular"></span>
                </div>
                <span class="nav-label">Kontakte</span>
              </div>
            </div>
          </div>

          <div [customRouterLink]="['/', 'revenues']" matRippleColor="rgba(255,255,255,0.15)" class="nav-entry"  [class.active]="isRouteActive('revenues')" matRipple>
            <div class="icon">
              <span class="iconify" data-icon="fluent:money-20-regular"></span>
            </div>
            <span class="nav-label">Umsätze</span>
          </div>


          <div class="nav-entry-wrapper" [class.active]="activeNav == 'accounting'">
            <div (click)="setActiveNav('accounting');$event.stopPropagation()" matRippleColor="rgba(255,255,255,0.15)" class="nav-entry" matRipple>
              <div class="icon">
                <span class="iconify" data-icon="la:file-invoice-dollar"></span>
              </div>
              <span class="nav-label">Buchhaltung</span>
            </div>
            <div class="nav-sub-entries">
              <div class="w-full" *ngFor="let company of (user$ | async).companies">
                <div class="text-2xs text-gray-500 uppercase pl-6 my-2">{{ company.name }}</div>
                <div *ngIf="(user$ | async)?.roles.indexOf('ROLE_CRM_ADMIN') >= 0" class="nav-sub-entry" [class.active]="isRouteActive('own-invoices/statistic')" [customRouterLink]="['/own-invoices', 'statistic']" [queryParams]="{ company: company.id }">
                  <div class="icon">
                    <span class="iconify" data-icon="ci:chart-line"></span>
                  </div>
                  <span class="nav-label">Statistiken</span>
                </div>
                <div class="nav-sub-entry" [class.active]="isRouteActive('client-invoices')" [customRouterLink]="['/', 'client-invoices']" [queryParams]="{ company: company.id }">
                  <div class="icon">
                    <span class="iconify" data-icon="la:file-invoice-dollar"></span>
                  </div>
                  <span class="nav-label">Mandantenrechnungen</span>
                </div>
                <div class="nav-sub-entry" [class.active]="isRouteActive('own-invoices')" [customRouterLink]="['/', 'own-invoices']" [queryParams]="{ company: company.id }">
                  <div class="icon">
                    <span class="iconify" data-icon="la:file-invoice-dollar"></span>
                  </div>
                  <span class="nav-label">Eigene Rechnungen</span>
                </div>
                <div class="nav-sub-entry" [class.active]="isRouteActive('duns')" [customRouterLink]="['/', 'duns']" [queryParams]="{ company: company.id }">
                  <div class="icon">
                    <span class="iconify" data-icon="ic:outline-assignment-late"></span>
                  </div>
                  <span class="nav-label">Mahnungen</span>
                </div>
                <div class="nav-sub-entry" [class.active]="isRouteActive('settlements')" [customRouterLink]="['/', 'settlements']" [queryParams]="{ company: company.id }">
                  <div class="icon">
                    <span class="iconify" data-icon="nimbus:invoice"></span>
                  </div>
                  <span class="nav-label">Abrechnungen</span>
                </div>
                <div class="nav-sub-entry" [class.active]="isRouteActive('commission-invoices')" [customRouterLink]="['/', 'commission-invoices']" [queryParams]="{ company: company.id }">
                  <div class="icon">
                    <span class="iconify" data-icon="material-symbols:difference-outline"></span>
                  </div>
                  <span class="nav-label">Provisionsrechnungen</span>
                </div>
                <div class="nav-sub-entry" [class.active]="isRouteActive('credit-invoices')" [customRouterLink]="['/', 'credit-invoices']" [queryParams]="{ company: company.id }">
                  <div class="icon">
                    <span class="iconify" data-icon="material-symbols:difference-outline"></span>
                  </div>
                  <span class="nav-label">Gutschriften</span>
                </div>
                <div *ngIf="(user$ | async)?.roles.indexOf('ROLE_CRM_ADMIN') >= 0" class="nav-sub-entry" [class.active]="isRouteActive('billing-cycles')" [customRouterLink]="['/', 'billing-cycles']" [queryParams]="{ company: company.id }">
                  <div class="icon">
                    <span class="iconify" data-icon="ri:repeat-one-fill"></span>
                  </div>
                  <span class="nav-label">Rechnungskreise</span>
                </div>
              </div>

            </div>
          </div>

            <div *ngIf="(user$ | async)?.roles.indexOf('ROLE_CRM_ADMIN') >= 0" class="nav-entry" [class.active]="isRouteActive('/statistics', true)" [customRouterLink]="['/statistics']">
                <div class="icon">
                    <span class="iconify" data-icon="ci:chart-line"></span>
                </div>
                <span class="nav-label">Statistiken</span>
            </div>

            <div *ngIf="(user$ | async)?.roles.indexOf('ROLE_CRM_ADMIN') >= 0" class="nav-entry" [class.active]="isRouteActive('/users', true)" [customRouterLink]="['/users']">
                <div class="icon">
                    <span class="iconify" data-icon="ci:user"></span>
                </div>
                <span class="nav-label">Benutzer</span>
            </div>


        </div>

        <div class="fixed bottom-0 left-0 ml-4 bg-white">
          <div class="text-xs text-gray-700 text-center mb-2 version">
              Version <span id="CRM_VERSION_NUMBER">0.47.3</span>
          </div>
        </div>
      </div>
    </mat-sidenav>

    <mat-sidenav-content #sidenavContent>

      <router-outlet></router-outlet>
      <div #breakpointSm class="block md:hidden"></div>
      <div #breakpointMd class="hidden md:block"></div>
      <div #breakpointLg class="hidden lg:block"></div>
      <div #breakpointXl class="hidden xl:block"></div>
    </mat-sidenav-content>

    <mat-sidenav class="border-l-0" #sidenav position="end"  [mode]="device.eq('sm') ? 'push' : 'side'" [(opened)]="rightSidebarOpened">
      <app-context-bar></app-context-bar>
    </mat-sidenav>
  </mat-sidenav-container>
  <app-add-overlay></app-add-overlay>
  <div *ngIf="!rightSidebarOpened" (click)="rightSidebarOpened=true" class="fixed right-0 px-2 md:hidden z-100" style="top:50vh;transform:translate(0, -50%)">
    <div class="bg-primary rounded-full h-32 w-2 bg-opacity-75"></div>
  </div>
</div>
